import axios from "axios";
import qs from "qs";
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  getClient: root + "/Client",
  getClientExport: root + "/Client/Export",
  getSource: root + "/Public/getSourceApi",
  getMarketer: root + "/Public/getMarketerApi",
  getIntentCourse: root + "/Public/getIntentCourseApi",
  gettoLossClient: root + "/Client/toLossClientApi",
  gettoMyClient: root + "/Client/toMyClientApi",
  addClient: root + "/Client/addClientAction",
  getclientOne: root + "/Client/clientOneApi",
  getclientOneTrack: root + "/Client/clientOneTrackApi",
  getFriendRelation: root + "/Public/getFriendRelationApi",
  addallotClient: root + "/Client/allotClientApi",
  getclientOneInvite: root + "/Client/clientOneInviteApi",
  getclientOneAudition: root + "/Client/clientOneAuditionApi",
  getCommode: root + "/Public/getCommodeApi",
  getTraceNote: root + "/Public/getTraceNoteApi",
  settingtrackClient: root + "/Client/trackClientAction",
  checkIntentionClient: root + "/Intentionclient/checkIntentionClientApi",
  editClient: root + "/Client/editClientAction",
  getClientName: root + "/Client/getClientNameApi",
  bindingClient: root + "/Client/bindingClientAction",
  getBindingClient: root + "/Client/getBindingClientApi",
  delFamilyRelation: root + "/Public/delFamilyRelationApi",
  delIntentionSource: root + "/Public/delIntentionSourceApi",
  getFamilyRelation: root + "/Public/getFamilyRelationApi",
  getActivity: root + "/Client/getActivityApi",
  getChannel: root + "/Public/getChannelApi",
  getAllSchoolApi: root + "/Api/getAllSchoolApi",
  getTransferCnameApi: root + "/Api/getTransferCnameApi",
  transferSchoolAction: root + "/Client/transferSchoolAction",

  getImportTrackApi: `${root}/Client/getImportTrackApi`, //招生有效名单管理->下载导入模版
  ImportTrack: `${root}/Client/ImportTrack`, //招生有效名单管理->导入招生有效名单

  SereachOne: `${root}/Client/SereachOne`, //招生有效名单管理->检索名单
  getRecruiter: `${root}/Client/getRecruiter`,
  migrationCrmApi: `${root}/Client/migrationCrmApi`,
};
const storeAdmissionCue = {
  //招生目标线索数据
  getClient(params) {
    return axios.get(url.getClient, {
      params,
    });
  },
  // 招生目标线索数据---导出
  getClient1() {
    return isGraySchoolEnabled() ? url.getClientExport:url.getClient;
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, {
      params,
    });
  },
  // 获取有效名单名称
  getActivity(params) {
    return axios.get(url.getActivity, {
      params,
    });
  },
  // 获取招生渠道明细
  getChannel(params) {
    return axios.get(url.getChannel, {
      params,
    });
  },
  // 获取招生的负责人
  getMarketer(params) {
    return axios.get(url.getMarketer, {
      params,
    });
  },
  //获取意向课程
  getIntentCourse(params) {
    return axios.get(url.getIntentCourse, {
      params,
    });
  },
  // 线索流转为无意向客户(批量无意向)
  gettoLossClient(params) {
    return axios.post(url.gettoLossClient, qs.stringify(params));
  },
  // 流转为我的意向客户
  gettoMyClient(params) {
    return axios.post(url.gettoMyClient, qs.stringify(params));
  },
  // 获取单个客户的基本信息
  getclientOne(params) {
    return axios.get(url.getclientOne, {
      params,
    });
  },
  // 获取单个客户的跟踪记录
  getclientOneTrack(params) {
    return axios.get(url.getclientOneTrack, {
      params,
    });
  },
  // 获取绑定关系
  getFriendRelation(params) {
    return axios.get(url.getFriendRelation, {
      params,
    });
  },
  // 获取单个客户的柜询记录-
  getclientOneInvite(params) {
    return axios.get(url.getclientOneInvite, {
      params,
    });
  },
  // 获取单个客户的试听记录-
  getclientOneAudition(params) {
    return axios.get(url.getclientOneAudition, {
      params,
    });
  },
  // 招生目标线索->获取单个客户绑定学员
  getBindingClient(params) {
    return axios.get(url.getBindingClient, {
      params,
    });
  },
  // 获取转校学校列表
  getAllSchoolApi(params) {
    return axios.get(url.getAllSchoolApi, {
      params,
    });
  },
  // 获取转校原因
  getTransferCnameApi(params) {
    return axios.get(url.getTransferCnameApi, {
      params,
    });
  },
  // 有效招生名单->转校
  transferSchoolAction(params) {
    return axios.post(url.transferSchoolAction, qs.stringify(params));
  },
  // 获取沟通类型
  getCommode(params) {
    return axios.get(url.getCommode, {
      params,
    });
  },
  // 获取家庭亲属关系
  getFamilyRelation(params) {
    return axios.get(url.getFamilyRelation, {
      params,
    });
  },
  // 获取沟通模板
  getTraceNote(params) {
    return axios.get(url.getTraceNote, {
      params,
    });
  },
  // 绑定学员->获取人员名称
  getClientName(params) {
    return axios.get(url.getClientName, {
      params,
    });
  },
  // 招生目标线索->跟进客户
  settingtrackClient(params) {
    return axios.post(url.settingtrackClient, qs.stringify(params));
  },
  // 招生目标线索->新增时-检测重名
  checkIntentionClient(params) {
    return axios.get(url.checkIntentionClient, {
      params,
    });
  },
  // 招生目标线索->为客户分配负责人
  addallotClient(params) {
    return axios.post(url.addallotClient, qs.stringify(params));
  },

  // 招生目标线索->绑定学员
  bindingClient(params) {
    return axios.post(url.bindingClient, qs.stringify(params));
  },
  // 新增招生线索
  addClient(params) {
    return axios.post(url.addClient, qs.stringify(params));
  },
  // 编辑招生线索
  editClient(params) {
    return axios.post(url.editClient, qs.stringify(params));
  },
  // 删除亲属关系
  delFamilyRelation(params) {
    return axios.post(url.delFamilyRelation, qs.stringify(params));
  },
  // 删除意向课程
  delIntentionSource(params) {
    return axios.post(url.delIntentionSource, qs.stringify(params));
  },

  //招生有效名单管理->下载导入模版
  getImportTrackApi(params) {
    return axios.get(url.getImportTrackApi, {
      params,
    });
  },
  //招生有效名单管理->导入招生有效名单
  ImportTrack(params) {
    return axios.post(url.ImportTrack, qs.stringify(params));
  },

  // 招生有效名单管理->检索名单
  SereachOne(params) {
    return axios.get(url.SereachOne, {
      params,
    });
  },
  getRecruiter(params) {
    return axios.get(url.getRecruiter, {
      params,
    });
  },
  migrationCrmApi(params) {
    return axios.post(url.migrationCrmApi, qs.stringify(params));
  },
};

export default storeAdmissionCue;
